/**
 * [pug template]
 * Moteur || type de commande
 */
<template lang="pug">
  div(:class="{ 'olst-field-error': hasError, 'olst-field-warning': hasWarning, 'olst-field-info': hasInfo }")
    div(class="olst-field-selection")
      label-component.olst-field-label.olst-field-label-a-b(:name="fieldRef", :text="getLabel()")
      //- label-component.olst-field-label.olst-field-label-a-b(:name="fieldRef", :text="'.'")
      select-with-picture-component(:name='fieldRef', :options='injectPictureInOption', :defaultField='cc_value', :disabled="isFieldDisable()", :hideLabel='true', v-on:value-changed="fieldChanged", cssClasses='flex-5-cols')
    .olst-field-validation-picture-field-alt(v-for="messages, key, index in field.validation", v-if="isValidationMessage(key)")
      div(v-for="message in messages", :class="{ 'olst-field-error': isTypeError(key), 'olst-field-warning': isTypeWarning(key), 'olst-field-infos': isTypeInfo(key) }").olst-field-info
        text-component(:text="__t(message)")
</template>
/**
 * [javascript application]
 */
<script>
import config from '../../../../config/global'
import { SelectionComputed, SelectionMethods, SelectionWatch } from '../../../../lib/inherited/selection'
import { RenderingUnitComputed, RenderingUnitMethods, RenderingUnitWatch } from '../../../../lib/inherited/rendering_unit.js'
import common from '../../../../lib/common/common'
export default {
  name: 'selection-info-label',
  props: {
    fieldRef: {
      type: String,
      default: ''
    },
    productReference: {
      type: String,
      default: null
    },
    version: {
      type: String,
      default: 'default'
    },
    field: {
      type: Object,
      default: { label: '', values: {}, tooltip: '' }
    },
    cc_value: {
      type: [Number, String],
      default: 0
    },
    uom: {
      type: String,
      default: 'cm'
    },
    mint: {
      type: Number,
      default: 0
    },
    cc: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      selected: this.cc_value
    }
  },
  components: config.components,
  computed: Object.assign({}, RenderingUnitComputed, SelectionComputed, {
    injectPictureInOption: function () {
      let me = this
      let fieldValues = common.cloneDataObject(this.field.values)
      Object.keys(fieldValues).map(function (valueRef) {
        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef)
        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef)
        switch (valueRef) {
          case 'OPT-1219_sangle':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_sangle.png'
            break
          case 'OPT-1220_treuil':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_treuil.png'
            break
          case 'OPT-1221_tirage-direct-avec-verrou':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_tirage-direct.png'
            break
          case 'OPT-1222_moteur-standard-filaire':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok.png'
            break
          case 'OPT-1223_moteur-somfy-filaire':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy.png'
            break
          case 'OPT-1224_moteur-standard-tlcommand':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok.png'
            break
          case 'OPT-1225_moteur-somfy-tlcommand':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy.png'
            break
          case 'OPT-1328_moteur-somfy-telecommande-io':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy-io.png'
            break
          case 'OPT-1431_moteur-standard-solaire':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok.png'
            break
          case 'OPT-1434_moteur-somfy-solaire':
            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy.png'
            break

          default:
            fieldValues[valueRef]['picture'] = ''
            break
        }
      })
      return fieldValues
    }
  }),
  methods: Object.assign({}, RenderingUnitMethods, SelectionMethods,
    {
      /**
       * Get field label
       * @return {Boolean}
       */
      getLabel: function () {
        return this.checkCmdFilter() ? 'Type de commande' : 'Moteur'
      },
      /**
       * Check commande filter
       */
      checkCmdFilter: function () {
        return this.cc.config_1.prefilled_values['CH-616_filtre-commande'] === 'OPT-2424_manuel' || this.cc.config_1.prefilled_values['CH-622_filtre-commande'] === 'OPT-2437_manuel'
      }
    }
  ),
  watch: Object.assign({}, RenderingUnitWatch, SelectionWatch)
}
</script>
/**
 * [scss styles]
 */
<style lang="scss">
</style>



// WEBPACK FOOTER //
// SelectionPictureCommande.vue?748bb5ed